

import { IThongKeSiSoSelectRequest } from "../../../models/request/thong-ke/IThongKeSiSoSelectRequest";
import { IThongKeCSKHByStatusRespone } from "../../../models/response/thong-ke/IThongKeCSKHByStatusRespone";
import { IThongKeItemBaseRespone } from "../../../models/response/thong-ke/IThongKeItemBaseRespone";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eThongKeCSKHActionDefine = {
   
    LOAD_START: {} as IThongKeSiSoSelectRequest,
    LOAD_SUCCESS: {} as IThongKeCSKHByStatusRespone[],
    LOAD_ERROR: "",

    LOAD_BY_MONTH_START: {} as IThongKeSiSoSelectRequest,
    LOAD_BY_MONTH_SUCCESS: {} as IThongKeItemBaseRespone[],
    LOAD_BY_MONTH_ERROR: "",

}
export const eThongKeCSKHActionTypeIds = generateActionTypeIds(eThongKeCSKHActionDefine, "THONG_KE_CSKH")

export type IThongKeCSKHActionTypes = IGenericActionType<typeof eThongKeCSKHActionDefine, "THONG_KE_CSKH">